// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { productCarouselProductCondensedStyles } from "@steiner/Overrides/Components/ProductCarouselProductCondensed";
import { color, ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductCondensedStyles.container = {
    css: css`
        position: relative;
        border-radius: 4px;
        aspect-ratio: 1;
        background-color: ${color("common.white")};
        box-shadow: 0 0 3px 0 ${color("common.ui7", 0.5)};
    `,
};

productCarouselProductCondensedStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 100%;
            height: 100%;
            padding: 5px;
            aspect-ratio: 1;
        `,
    },
    img: {
        css: css`
            max-width: 100%;
            max-height: 100%;
            height: auto;
            width: auto;
            aspect-ratio: 1;
            ${ellipsis(3)}
        `,
    },
};

productCarouselProductCondensedStyles.tooltip = {
    mergeCss: true,
    floatingTooltipProps: {
        tooltipContent: {
            css: css`
                z-index: ${getProp("theme.zIndex.compareFlyoutTooltip")};
            `,
        },
    },
};
